import TimeUnitDropdown from "components/basic/dropdowns/time-unit-dropdown/TimeUnitDropdown";
import { IProductTemplateTableEditor } from "components/ComponentType";
import { DropdownChangeEvent } from "primereact/dropdown";
import { InputNumber, InputNumberValueChangeEvent } from "primereact/inputnumber";
import { InputSwitch } from "primereact/inputswitch";
import React, { useState } from "react";
import { T } from "services/lang/LanguageService";

interface ProducetTemplateLoadConfigProps {
  currentConfig: IProductTemplateTableEditor;
  setCurrentConfig: React.Dispatch<React.SetStateAction<IProductTemplateTableEditor>>;
}

const ProductTemplateLoadConfig = ({
  currentConfig,
  setCurrentConfig,
}: ProducetTemplateLoadConfigProps) => {
  const [overrideConfig, setOverrideConfig] = useState(!!currentConfig.overrideLoadingConfig);

  const overrideConfigHandler = () => {
    if (overrideConfig) {
      setCurrentConfig(prev => ({ ...prev, overrideLoadingConfig: undefined }));
    }
    setOverrideConfig(prev => !prev);
  };

  const loadingConfigHandler = (e: InputNumberValueChangeEvent | DropdownChangeEvent) => {
    setCurrentConfig(prevState => ({
      ...prevState,
      overrideLoadingConfig: {
        ...prevState.overrideLoadingConfig,
        loadingConfig: {
          ...prevState.overrideLoadingConfig?.loadingConfig,
          [e.target.id]: !Number.isNaN(Number(e.target.value))
            ? e.target.value
            : e.target.value.toString().toUpperCase(),
        },
      },
    }));
  };

  return (
    <div>
      <div className="gap-2 flex flex-column">
        <label htmlFor="overrideConfig">{T("component.override-config")}</label>
        <InputSwitch
          id="overrideConfig"
          checked={overrideConfig}
          onChange={overrideConfigHandler}
        />
      </div>
      <div className="w-full flex flex-wrap md:flex-nowrap gap-3 mb-3 mt-3">
        <div className="w-8 md:w-6 gap-2 flex flex-column justify-content-center align-items-center">
          <label htmlFor="period">{T("load-conf.period")}</label>
          <div className="p-inputgroup">
            <InputNumber
              id="period"
              className="w-6"
              value={currentConfig.overrideLoadingConfig?.loadingConfig?.period}
              onValueChange={loadingConfigHandler}
              disabled={!overrideConfig}
            />
            <TimeUnitDropdown
              id="periodUnit"
              className="p-inputgroup-addon p-0 w-6"
              value={currentConfig.overrideLoadingConfig?.loadingConfig?.periodUnit || ""}
              onChange={loadingConfigHandler}
              disabled={!overrideConfig}
            />
          </div>
        </div>
        <div className="w-8 md:w-6 gap-2 flex flex-column justify-content-center align-items-center">
          <label htmlFor="offset">{T("load-conf.offset")}</label>
          <div className="p-inputgroup">
            <InputNumber
              id="offset"
              value={currentConfig.overrideLoadingConfig?.loadingConfig?.offset}
              className="w-6"
              onValueChange={loadingConfigHandler}
              disabled={!overrideConfig}
            />
            <TimeUnitDropdown
              id="offsetUnit"
              className="p-inputgroup-addon p-0 w-6"
              value={currentConfig.overrideLoadingConfig?.loadingConfig?.offsetUnit || ""}
              onChange={loadingConfigHandler}
              disabled={!overrideConfig}
            />
          </div>
        </div>
        <div className="w-5 md:w-3 gap-2 flex flex-column justify-content-center align-items-center">
          <label htmlFor="defaultConfigUnit">{T("load-conf.default-config-unit")}</label>
          <TimeUnitDropdown
            id="defaultConfigUnit"
            className="w-full"
            value={currentConfig.overrideLoadingConfig?.loadingConfig?.defaultConfigUnit || ""}
            onChange={loadingConfigHandler}
            disabled={!overrideConfig}
          />
        </div>
        <div className="w-5 md:w-3 gap-2 flex flex-column justify-content-center align-items-center">
          <label htmlFor="truncateStartUnit">{T("load-conf.truncate-start-unit")}</label>
          <TimeUnitDropdown
            id="truncateStartUnit"
            className="w-full"
            value={currentConfig?.overrideLoadingConfig?.loadingConfig?.truncateStartUnit || ""}
            onChange={loadingConfigHandler}
            disabled={!overrideConfig}
          />
        </div>
      </div>
    </div>
  );
};

export default ProductTemplateLoadConfig;
